export var zIndex = {
  negative: -1,
  default: 1,
  header: 5,
  overlay: 1000,
  navigation: 2000,
  navigationContent: 2001,
  modal: 5000,
  tooltip: 6000,
  toast: 8000
};
export default zIndex;